import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "../lib/data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-cream/85 backdrop-blur-md border-b border-maroon/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#home" data-testid="logo-link" className="flex items-center gap-3 group">
          <span className={`grid place-items-center h-10 w-10 rounded-full border ${scrolled ? "border-maroon text-maroon" : "border-cream/70 text-cream"} transition-colors`}>
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M7.5 4.5 C7.5 12, 9 15, 12 16 C15 15, 16.5 12, 16.5 4.5" />
              <path d="M12 8.5 L12 16" />
              <path d="M12 5 C10.6 6.4, 10.6 8, 12 9 C13.4 8, 13.4 6.4, 12 5 Z" fill="currentColor" stroke="none" />
            </svg>
          </span>
          <span className="leading-tight">
            <span className={`block ff-display text-lg ${scrolled ? "text-ink" : "text-cream"} transition-colors`}>
              Bhakti Svarup
            </span>
            <span className={`block text-[10px] uppercase tracking-[0.24em] ${scrolled ? "text-maroon" : "text-saffron"}`}>
              Vidya Niketan
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={`relative text-sm tracking-wide group ${scrolled ? "text-ink" : "text-cream"}`}
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-saffron transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="#admissions"
            data-testid="header-apply-btn"
            className="ml-2 px-5 py-2 rounded-full bg-maroon text-cream text-sm tracking-wide hover:bg-saffron hover:text-ink transition-colors duration-300"
          >
            Apply Now
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden ${scrolled ? "text-ink" : "text-cream"}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-nav"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-cream border-b border-maroon/10"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="ff-display text-2xl text-ink"
                >
                  {n.label}
                </a>
              ))}
              <a href="#admissions" onClick={() => setOpen(false)} className="mt-2 px-5 py-3 text-center rounded-full bg-maroon text-cream">
                Apply Now
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
